export default "__VITE_ASSET__BnfSKl76__"